export function SubmenuDivider() {
    return <hr className="desktop-navigation-submenu-divider" />
}
